<template lang="pug">
  v-dialog(v-model="show" width="500" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent)
    v-card.d-flex.flex-column(flat)
        v-card-title {{ $t('settingsPage.deleteKey') }}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
            v-row(v-if="$vuetify.breakpoint.mdAndUp")
              v-col.text-center(cols="12")
                span.title.text-center {{ $t('settingsPage.deleteKeyLabel') }} ?
            v-row.text-center(v-else align="center" )
              v-col(cols="12" align="center")
                span.title {{ $t('settingsPage.deleteKeyLabel') }} ?
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="onCancelButtonClick" :disabled="inProgress") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn(color="primary" @click="onSubmitButtonClick" :loading="inProgress") {{ $t('settingsPage.deleteButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';

@Component({})

export default class DeleteTokenDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Object, required: false }) readonly selectedKey!: any
  @Prop({ type: Number, required: false }) readonly indexClicked!: any

  private inProgress: boolean = false

  onSubmitButtonClick (): void {
    this.inProgress = true
    this.$emit('yes',this.selectedKey,this.indexClicked)
  }

  onCancelButtonClick (): void {
    this.inProgress = true
    this.$emit('close')
  }

  mounted() {
  }
}

</script>

<style lang="stylus" scoped>

</style>
